import React from 'react';

const STATUS_STYLES = {
  new: { bg: '#E0F2FE', text: '#0369A1' },
  contacted: { bg: '#FEF9C3', text: '#A16207' },
  needs_follow_up: { bg: '#FFF7ED', text: '#C2410C' },
  replied: { bg: '#DCFCE7', text: '#166534' },
  closed: { bg: '#FEE2E2', text: '#991B1B' },
};

export default function LeadStatusBadge({ status }) {
  const style = STATUS_STYLES[status] || { bg: '#F3F4F6', text: '#374151' };
  return (
    <span
      className="px-3 py-1 rounded-full text-sm font-medium"
      style={{ backgroundColor: style.bg, color: style.text }}
    >
      {status.replace('_', ' ')}
    </span>
  );
}